import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import EToolTip from 'components/others/EToolTip';
import SolarIcon from 'components/icons/SolarIcon';
import OffWarrantyFilter from './OffWarrantyFilter';
import { useWarrantyFilters } from './model';

const WarrantiesFilter = () => {
    const { t } = useTranslation('Warranties');
    const filter = useWarrantyFilters();

    return (
        <>
            <EToolTip title={t('filterTitle')}>
                <span className="d-inline-block">
                    <Button
                        className="fs-14 px-2"
                        size="sm"
                        variant={filter.active ? 'danger' : 'primary'}
                        aria-label={t('filterTitle')}
                        onClick={(event) => {
                            event.currentTarget.blur();
                            filter.open();
                        }}
                    >
                        <SolarIcon name="funnel" className="fs-14 p-0" />
                    </Button>
                </span>
            </EToolTip>
            <OffWarrantyFilter filter={filter} />
        </>
    );
};

export default WarrantiesFilter;
